const tentativasPorImagem = 5;
window.tentativas = {};
/**
 * Define o source da imagem com erro para outra imagem
 *
 * @param {*} evt
 * @param {*} fallbackSource
 */
function imageFallback(evt, fallbackSource, id) {
    // Previnir recursividade
    window.tentativas[id || fallbackSource] = window.tentativas[id || fallbackSource] ?
        window.tentativas[id || fallbackSource] :
        0;

    if (window.tentativas[id || fallbackSource] < tentativasPorImagem) {
        window.tentativas[id || fallbackSource]++;
        evt.target.src = fallbackSource || "assets/media/animais/blank.svg";
    } else {
        evt.target.remove();
    }
}

window.imageFallback = imageFallback;
